import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "./app.reducer";
import { IconRegistryService } from "./shared/services/icon-registry.service";
import { NavigationService } from "./shared/services/navigation.service";
import { IconOptions } from "@angular/material/icon";
import { Actions, ofType } from "@ngrx/effects";
import { Subscription, take } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { AuthActions } from "./shared/auth/auth.actions";
import { AppInitResolverService } from "./shared/services/app-init-resolver.service";
import { AuthService } from "./shared/auth/auth.service";
import {
  Router,
  Event,
  NavigationStart,
  NavigationEnd,
  NavigationError,
} from "@angular/router";
import { AuthSite } from "./shared/auth/models/auth-logspace-locator.model";
import { environment } from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = "bdpweb";

  // Site-wide maintenance banner. Seeded from the compile-time environment,
  // then overridden at runtime by /assets/maintenance.json (if present) so it
  // can be toggled without a rebuild.
  maintenanceActive = environment.maintenance?.active ?? false;
  maintenanceMessage = environment.maintenance?.message ?? "";

  constructor(
    private iconRegistryService: IconRegistryService,
    private store: Store<AppState>,
    private navigation: NavigationService,
    private actions$: Actions,
    private appInitResolver: AppInitResolverService,
    private auth: AuthService,
    private router: Router,
  ) {
    this.navigation.startToSaveHistory();
  }

  ngOnInit() {
    this.iconRegistryService.registerCustomIconFont();
    this.refreshMaintenanceStatus();
  }

  // Best-effort runtime override. A static /assets/maintenance.json lets ops
  // flip the banner on/off without rebuilding the Angular bundle. Any failure
  // (missing file, offline) silently falls back to the compile-time default.
  private refreshMaintenanceStatus(): void {
    fetch("/assets/maintenance.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((cfg) => {
        if (cfg && typeof cfg.active === "boolean") {
          this.maintenanceActive = cfg.active;
          if (cfg.message) {
            this.maintenanceMessage = cfg.message;
          }
        }
      })
      .catch(() => {
        /* keep compile-time default */
      });
  }
}
